<template>
  <v-col cols="12" md="4" align="center" justify="center">
    <AddButton
      :title="this.$t('volunteer_experiences')"
      @click="openDialog()"
    />
    <BaseDraggable v-model="resume.volunteerExperiences">
      <DeletableCard
        v-for="(experience, i) in resume.volunteerExperiences"
        :key="i"
        :index="i"
        name="volunteerExperiences"
      >
        <p class="primary--text">
          {{ experience.role }} | {{ experience.organization }}
        </p>
        <p v-if="experience.description" class="primary--text">
          {{ experience.description }}
        </p>
        <p class="primary--text">
          {{ experience.startDate }} |
          {{ experience.present ? present : experience.endDate }}
        </p>
      </DeletableCard>
    </BaseDraggable>
    <AddVolunteerExperienceDialog
      :showCondition="showDialog"
      @closed="closeDialog()"
    />
  </v-col>
</template>

<script>
import { mapState } from "pinia";
import { useCreateResumeStore } from "../../store/CreateResumeStore";

import AddButton from "../buttons/AddButton.vue";
import DeletableCard from "../DeletableCard.vue";
import AddVolunteerExperienceDialog from "../dialogs/AddVolunteerExperienceDialog.vue";

export default {
  components: { AddButton, DeletableCard, AddVolunteerExperienceDialog },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapState(useCreateResumeStore, ["resume"]),
    present() {
      return this.$t("present");
    },
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
  },
};
</script>

<style></style>
